import React, { useRef, useState } from "react";
import { api, formatError } from "@/lib/api";
import { toast } from "sonner";
import { Upload, X } from "lucide-react";

export default function PhotoUpload({ value, onChange, label = "Niraj's photo", testid = "niraj-photo" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Photo uploaded");
    } catch (err) { toast.error(formatError(err)); } finally { setUploading(false); }
  };

  const clear = () => onChange("");
  const preview = value ? (value.startsWith("http") || value.startsWith("/") ? value : "") : "";
  const src = preview.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${preview}` : preview;

  return (
    <div className="glass rounded-2xl p-6" data-testid={`${testid}-block`}>
      <div className="overline mb-3">{label}</div>
      <div className="flex items-start gap-6">
        <div className="w-32 h-40 rounded-xl overflow-hidden border border-ink-900/10 bg-cream-100 flex items-center justify-center">
          {src ? (
            <img src={src} alt="Niraj" className="w-full h-full object-cover" data-testid={`${testid}-preview`} />
          ) : (
            <div className="text-ink-400 text-xs text-center px-2">No photo yet</div>
          )}
        </div>
        <div className="flex-1 space-y-3">
          <input type="file" accept="image/*" ref={inputRef} onChange={(e) => upload(e.target.files?.[0])} className="hidden" data-testid={`${testid}-file-input`} />
          <div className="flex flex-wrap gap-2">
            <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading} className="btn-neon !py-2 !px-4 text-sm disabled:opacity-60" data-testid={`${testid}-upload-btn`}>
              <Upload className="w-4 h-4 mr-1.5" /> {uploading ? "Uploading..." : value ? "Change photo" : "Upload photo"}
            </button>
            {value && (
              <button type="button" onClick={clear} className="btn-ghost !py-2 !px-4 text-sm" data-testid={`${testid}-remove-btn`}>
                <X className="w-4 h-4 mr-1.5" /> Remove
              </button>
            )}
          </div>
          <div className="text-xs text-ink-500">JPG, PNG, WEBP, GIF or SVG. Max 8MB.</div>
          <label className="block">
            <div className="overline mb-1 !text-ink-600">Or paste an image URL</div>
            <input value={value || ""} onChange={(e) => onChange(e.target.value)}
              placeholder="https://..." className="w-full rounded-lg bg-cream-50 border border-ink-900/15 px-3 py-2 outline-none focus:border-gold text-ink-900 text-sm"
              data-testid={`${testid}-url-input`} />
          </label>
        </div>
      </div>
    </div>
  );
}
